<template>
  <div aria-label="checkbox-group" class="v-checkbox-group" :class="classes" role="group">
    <slot />

    <VErrors :errors />
  </div>
</template>

<script setup lang="ts">
import { computed, inject, provide } from 'vue'

import { useErrors } from '../composables/useErrors.ts'
import type { VCheckboxGroupType } from '../types.ts'
import { $checkboxGroupKey, $formKey } from '../utils/injections.ts'
import VErrors from './VErrors.vue'

export interface Props {
  horizontal?: boolean
  error?: string | string[]
  prop?: string
  type?: VCheckboxGroupType
}

const props = withDefaults(defineProps<Props>(), {
  horizontal: false,
  error: '',
  prop: '',
  type: '',
})

const model = defineModel<(string | number)[]>({ required: true })

defineSlots<{
  default?(): any
}>()

const form = inject($formKey, undefined)
const errors = useErrors(props)

const classes = computed(() => ({
  [`v-checkbox-group--${props.type}`]: props.type,
  'v-checkbox-group--horizontal': props.horizontal,
}))

function input(label: string | number) {
  const index = model.value.indexOf(label)

  const value = [...model.value]

  if (index >= 0) {
    value.splice(index, 1)
  } else {
    value.push(label)
  }

  model.value = value

  if (props.prop) {
    form?.validateOneProp(props.prop)
  }
}

provide($checkboxGroupKey, {
  props,
  model,
  input,
})
</script>

<style>
.v-checkbox-group .v-errors {
  padding: 0;
}
</style>
